<template>
  <div class="content ">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <card class="strpied-tabled-with-hover" body-classes="table-full-width table-responsive">
            <template slot="header">
              <div class="row">
                <div class="col-10">
                  <h4 class="card-title">Ürün Kategorileri</h4>
                  <p class="card-category">Elinizdeki ürünleri kategorilere ayırarak daha kolay yönetebilirsiniz.</p>
                </div>
                <div class="col-2">
                  <button type="submit" class="btn btn-success btn-fill float-right mr-3" @click="createNew()">
                    Yeni Oluştur
                  </button>
                </div>

              </div>



              <div class="row p-3">
                <div class="col-3 ml-2">
                  <input class="form-control form-control-lg bg-light text-dark placeholder-dark"
                    @input="debounceGetCategories" v-model="queryText" type="text" placeholder="Arama">
                </div>

              </div>


            </template>


            <table class="table table-hover table-striped">
              <thead>
                <slot name="columns">
                  <tr>
                    <th v-for="column in tableColumns" :key="column">{{ column }}</th>
                  </tr>
                </slot>
              </thead>
              <tbody>
                <tr v-for="(item, index) in tableData" :key="item._id">
                  <slot :row="item">
                    <td>{{ item.name }}</td>
                    <td>{{ item.parentCategory ? item.parentCategory.name : '-' }}</td>
                    <td>{{ item.items.length }}</td>
                    <td>{{ item.isActive ? 'Evet' : 'Hayır' }}</td>
                    <td @click="openDeleteModal(item)"><button><i class="nc-icon nc-simple-remove"></i></button></td>
                    <td @click="editCategory(item._id)"><button><i class="nc-icon nc-settings-tool-66"></i></button></td>
                  </slot>
                </tr>
              </tbody>
            </table>
            <nav aria-label="...">
              <ul class="pagination text-center" style="margin-left: 45%;">
           
                <li class="page-item"
                  v-for="i of (pagination.totalPages > 1 ? Array.from(Array(pagination.totalPages).keys()).slice(pagination.currentPage > 3 ? pagination.currentPage - 3 : 0, pagination.currentPage + pagination.layOutMax) : [0])"
                  :class="pagination.currentPage == i + 1 ? 'active' : ''" @click="paginationGet(i + 1)"><a
                    class="page-link">{{ i + 1 }}</a></li>


              
              </ul>
            </nav>
          </card>

        </div>


        <div class="modal fade show bg-gray" tabindex="-1"
          :style="deleteModal.isOpened == true ? 'display: block;' : 'display: none;'" aria-modal="true" role="dialog">
          <div class="modal-dialog" v-if="deleteModal.category">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLiveLabel">Kategoriyi silmek istediğinize emin misiniz?</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                  @click="deleteModal.isOpened = false">
                  <span aria-hidden="true">×</span>
                </button>
              </div>

              <div class="modal-body">
                <label><strong>Kategori Adı:</strong> {{ deleteModal.category.name }}</label><br>
                <label><strong>Üst Kategori:</strong> {{ deleteModal.category.parentCategory ?
                  deleteModal.category.parentCategory.name : '-' }}</label><br>
                <label><strong>Ürün Sayısı:</strong> {{ deleteModal.category.items.length }}</label><br>
                <label><strong>Aktif mi?:</strong> {{ deleteModal.category.isActive ? 'Evet' : 'Hayır' }}</label><br>
              </div>
              <div class="modal-footer">

                <button type="button" @click="openDeleteModal(null)" class="btn btn-secondary"
                  data-dismiss="modal">Kapat</button>
                <button type="button" @click="deleteCategory(deleteModal.category._id)"
                  class="btn btn-primary">Sil!</button>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
import Card from 'src/components/Cards/Card.vue'
import CollectionService from "../../services/collection.service.js";


const tableColumns = ['Kategori Adı', 'Üst Kategori', 'Ürün Sayısı', 'Aktif mi?']
export default {
  components: {
    Card
  },
  data() {
    return {
      tableColumns,
      tableData: [],
      pagination: {
        currentPage: 1,
        totalPages: 0,
        itemsPerPage: 10,
        layOutMax: 3
      },
      queryText: '',
      deleteModal: {
        isOpened: false,
        category: null
      },
      searchInterval: null
    }
  },
  mounted() {
    this.getCategories();

  },
  methods: {
    paginationGet(i) {
      this.pagination.currentPage = Number(i);
      this.getCategories();
      window.scroll({ top: 0, behavior: "smooth" })
    },
    getCategories() {
      let q = { name: this.queryText };
      let p = {};
      let o = { skip: (this.pagination.currentPage - 1) * this.pagination.itemsPerPage, limit: this.pagination.itemsPerPage, sort: { createdAt: 1 } }

      let query = `q=${JSON.stringify(q)}&p=${JSON.stringify(p)}&o=${JSON.stringify(o)}`

      CollectionService.getCollection('category', query).then((res) => {
        if (res.success == true) {
          this.tableData = res.categories;
          this.pagination.totalPages = Math.ceil(res.count / this.pagination.itemsPerPage);
        } else {
          console.log('error');
        }
      })
    },
    deleteCategory(_id) {
      CollectionService.deleteItem('category', _id).then((res) => {
        this.notifyVue('bottom', 'right', 'danger', ` ${this.deleteModal.category.name} ürün kategorisi silindi.`)
        this.deleteModal.isOpened = false;
        this.deleteModal.category = null;
        this.getCategories();
      })
    },
    openDeleteModal(category) {
      this.deleteModal.isOpened = !this.deleteModal.isOpened
      this.deleteModal.category = category;
    },
    editCategory(_id) {
      this.$router.push(`/admin/categories/${_id}`);
    },
    createNew() {
      this.$router.push(`/admin/categories/create`);
    },
    notifyVue(verticalAlign, horizontalAlign, type, message) {
      this.$notifications.notify(
        {
          message: JSON.stringify(message),
          icon: '',
          horizontalAlign: horizontalAlign,
          verticalAlign: verticalAlign,
          type
        })
    },
    debounceGetCategories() {
      if (this.searchInterval) {
        clearTimeout(this.searchInterval);
      }
      this.searchInterval = setTimeout(() => {
        this.getCategories();
      }, 250);
    }
  }
}
</script>
<style></style>